import React, { useState, useEffect } from 'react';
import styled from "styled-components";

const Wrapper = styled.div`
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.75);
`;

const ModalStyle = styled.div`
  transform: translate(0%, -50%);
  background-color: white;
  z-index: 1000;
  border: 3px solid rgb(89, 113, 130);
  z-index: 2;
`;

const OverlayStyle = styled.div`
  position: fixed;
  top: ${props => props.scrollPosition}px;
  @media screen and (max-width: 768px) {
    top: 0px;
  }
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* semi-transparent overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

`;

const Header = styled.div`
  background: white;
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  padding-right: 8px;

  p {
    font-weight: 700;
    padding-left: 16px;
    font-size: large;
    margin-top: 0px;
    margin-bottom: 8px;
  }
  span {
    font-size: large;
    font-weight: 700;
  }
`;
const Content = styled.div`
  background: rgb(247, 247, 247);
  min-height: 62px;
`;

const ModalButton = styled.div`
  background-color: #515151;
  color: #fff;
  height: 30px;
  position: relative;
  z-index: 0;
  ${
    "" /* top: -3px;
  right: -3px; */
  }
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  p {
    color: #fff;
    position: relative;
    bottom: 2px;
    left: 2px;
  }
`;

export default function SettingWrapper(props) {
  const [scrollPosition, setScrollPosition] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset || document.documentElement.scrollTop;
      setScrollPosition(position);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const openModal = () => {
    if (!!props.link) {
      window.open(props.link, '_blank');
      return
    }
    setIsModalOpen(true);
    document.body.style.overflow = "hidden"; // Inhibit scroll
  };

  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = "auto"; // Enable scroll
  };
  return (
    <Wrapper>
      <Header>
        <p>{props.title}</p>
        {props.popupTitle || props.popupElement ? (
          <ModalButton onClick={openModal}>
            <span>?</span>
          </ModalButton>
        ) : null}
      </Header>
      <Content>{props.children}</Content>
      {isModalOpen ? (
        <>
          <OverlayStyle onClick={closeModal} id="overlay" scrollPosition={scrollPosition}>

          <ModalStyle id="modal">
            <Header>
              <h1 style={{ paddingLeft: "12px", paddingRight: "12px" }}>
                {props.title}
              </h1>
              <ModalButton onClick={closeModal}>
                <span>X</span>
              </ModalButton>
            </Header>
            <Content>
              {props.popupDescription && <p>{props.popupDescription}</p>}
              {props.popupElement}
            </Content>
          </ModalStyle>
          </OverlayStyle>
        </>
      ) : null}
    </Wrapper>
  );
}
